// @flow

import type {Effect} from '../../types'

import {
  take,
  call,
  select,
  put,
} from 'redux-saga/effects'
import {
  actionTypes as routerTypes,
} from 'redux-router5'
import {hideMap} from '../../map/lib/hideMap'
import {fetchServiceProvidersByCity} from '../lib/fetchServiceProvidersByCity'
import {ensureMapReady} from '../../map/effects/ensureMapReady'
import {mapSelectors} from '../../map/selectors'
import {placeActions} from '../actions'
import {partnerPlacesToServiceProviders} from '../lib/partnerPlacesToServiceProviders'

export function* enterPlaceListEffect(): Effect {
  while (true) {
    const {payload: {route}} = yield take(routerTypes.TRANSITION_SUCCESS)
    if (route.name === 'place-list') {
      yield put(placeActions.setPlaceList([]))
      yield call(ensureMapReady)
      try {
        yield call(hideMap)
        const apiIndex: ApiIndex<MapApi> = yield select(mapSelectors.getApiIndex)
        if (route.params.city) {
          const paging: PaginationResponse<PartnerPlace>  = yield call(fetchServiceProvidersByCity, apiIndex,route.params.city, route.params.district, route.params.page)
          const places: ServiceProvider[] = yield call(partnerPlacesToServiceProviders, paging)
          yield put(placeActions.setPlaceList(places))
          yield put(placeActions.setPagination(paging))
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
